export default __webpack_public_path__ + "static/media/sanmat3.257e20cb.jpg";